export default {
    header: 'Aproveite e complete sua experiência:',

    fireTag: 'EM ALTA',

    badge: {
        discount: 'DE DESCONTO'
    },

    card: {
        originalPricePrefix: 'De',
        originalPriceSuffix: 'por apenas',
        newPriceSeparator: 'ou',
        fullPriceSuffix: 'à vista',
        ratingLabel: 'Bem avaliado!',
        button: 'Comprar Agora',
        acquired: 'Adquirido'
    },

    cards: {
        loveMap: 'Mapa do Amor',
        guide2026: 'Previsões 2026',
        chakrasGuide: 'Guia de Chakras'
    },

    benefits: {
        personalizedContent: 'Conteúdo personalizado',
        immediateRelease: 'Liberação imediata',
        alsoInAudio: 'Também em áudio',
        lifetimeAccess: 'Acesso vitalício'
    }
};
